module.exports = __webpack_public_path__ + "static/media/P14.c6b1f82c.jpg";